import React, { useState } from 'react';
import { Button, FileUpload, OverlaySpinner, Select } from '@insurancemenu/imenu-components-lib';
import { AcceptedFiles } from '@insurancemenu/imenu-components-lib/dist/types/FileUpload';
import { observer } from 'mobx-react-lite';
import StepHeader from 'components/common/headers/StepHeader';
import { generatePath, useHistory } from 'react-router-dom';
import { getRenewalEffectiveDateOptions } from 'global/utils/renewalsEffectiveDates';
import { useUploadAllExhibitsPageStore } from 'store/pages/tools/upload-all-exhibits/pageStore';
import { ROUTES_CONFIG_V2, RouteV2Id } from 'routes/routesConfigV2';
import { createStyles } from './styles';

const UploadExhibitsContent: React.FC = observer(() => {
  const history = useHistory();
  const { uploadAllExhibits, isFileUploadReset, isLoading } = useUploadAllExhibitsPageStore();

  const now = new Date();
  now.setDate(1);
  const date = now.toISOString().slice(0, 10);

  const [files, setFiles] = useState<AcceptedFiles>({});
  const [effectiveDate, setEffectiveDate] = useState(date);

  const onRedirectBack = (): void => {
    history.push(generatePath(ROUTES_CONFIG_V2[RouteV2Id.TRIGGER_RENEWALS].path));
  };

  const classes = createStyles();
  return (
    <div className={classes.content}>
      <div className={classes.actionBar}>
        <Select
          label="Effective Date"
          name="effectiveDate"
          options={getRenewalEffectiveDateOptions()}
          onChange={(e: React.ChangeEvent<HTMLSelectElement>): void => {
            setEffectiveDate(e.target.value);
          }}
          value={effectiveDate}
          width="23rem"
          validationPassed={!!effectiveDate}
          validationMessage="Please select effective date"
        />
      </div>
      <div className={classes.uploadsWrapper}>
        <StepHeader
          stepNumber="1"
          stepTitle="Import file exhibits"
          stepSubtitle={
            <p className={classes.subtitleStyled}>
              You can import your files here. Either drag and drop the files in the dotted box or select the button
              below to open up a dialogue box.
            </p>
          }
        />

        <div className={classes.uploadFileWrapper}>
          <FileUpload
            fileMimeTypes={[]}
            replaceSpecialCharacters={false}
            shouldBeReset={isFileUploadReset}
            onChange={(acceptedFiles): void => {
              setFiles(acceptedFiles);
            }}
          />
        </div>
      </div>
      <div className={classes.uploadsWrapper}>
        <StepHeader stepNumber="2" stepTitle="Upload exhibits" />
        <div className={classes.buttonWrapper}>
          <Button type="outlined" onClick={onRedirectBack} size="large">
            Back
          </Button>
          <Button
            onClick={(): void => {
              void uploadAllExhibits(files, effectiveDate);
            }}
            disabled={Object.keys(files).length === 0 || isLoading}
            size="large"
            color="primary"
          >
            Upload
          </Button>
        </div>
        {isLoading && <OverlaySpinner display={isLoading} />}
      </div>
    </div>
  );
});

export default UploadExhibitsContent;
